import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserRightsService {
  public userId: number;
  public userData: any;
  public IsAdmin: boolean = false;
  public RO_PP_Poweruser: boolean = false;
  public RO_PP_Worker: boolean = false;
  public RO_PP_Finance: boolean = false;
  public RO_Project_Manager: boolean = false;
  public RO_Construction_Manager: boolean = false;
  public EPG_Supervisor: boolean = false;
  public EPG_Engineer: boolean = false;
  public EPG_Construction_Manager: boolean = false;
  public EPG_Project_Manager: boolean = false;
  public EPG_Worker: boolean = false;
  public EPG_Finance: boolean = false;
  public Partner_User: boolean = false;
  public Supplier_Worker: boolean = false;
  public Supplier_Manager: boolean = false;
  public Supplier_Project_Manager: boolean = false;
  public Supplier_User: boolean = false;

  constructor() {
  }

  /**
  * @name isInputDisabled
  * @description it is used to lock some inputs and buttons,
  * in each component based on the user roles.
  */
  isInputDisabled(): boolean {
    return !(this.RO_Project_Manager || this.IsAdmin || this.RO_PP_Poweruser || this.RO_PP_Worker);
  }

  /**
   * @name hasCompletedRolloutRights
   * @returns {boolean} True if any of the roles have completed rollout rights, otherwise false.
   * @description Checks if any of the specified roles have completed rollout rights.
   *  This function manages the visibility of menus for all Rollout parts in the app.
   */
  hasCompletedRolloutRights(): boolean {
    return this.RO_Project_Manager || this.IsAdmin || this.RO_PP_Poweruser;
  }

  /**
   * @name hasCompletedEpgRights
   * @returns {boolean} True if any of the roles have completed EPG rights, otherwise false.
   * @description Checks if any of the specified roles have completed EPG rights.
   *  This function manages the visibility of menus for all EPG parts in the app.
   */
  hasCompletedEpgRights(): boolean {
    return this.IsAdmin || this.EPG_Supervisor;
  }

  isSupplierExternalWorker(): boolean {
    return this.Partner_User && this.Supplier_Worker;
  }

  isSupplierWorker(): boolean {
    return this.Supplier_Worker || this.Supplier_Manager || this.Supplier_Project_Manager || this.Supplier_User;
  }
}
